module.exports = __webpack_public_path__ + "img/1frasco.99cd6f6d.png";